import { BullhornOutlineIcon } from './BullhornOutlineIcon';

/**
 * author: Google
 * id B48B1E77-750E-4A16-9154-12D25E572A9D
 * name bullhorn-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bullhorn-outline.svg
 * tags
 */
export const AnnouncementOutlineIcon = BullhornOutlineIcon;
export default AnnouncementOutlineIcon